import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import App from './components/App';
import GlobalStyle from './style/global';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

ReactDOM.render(
  <Wrapper>
    <GlobalStyle />
    <Provider store={store}>
      <App />
    </Provider>
  </Wrapper>,
  document.getElementById('root'),
);
